import React, { useContext, useEffect, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { LinearProgress } from '@mui/material';

export default function TouchpointTable({ engagementTouchpoint }) {
  const renderParentCell = () => {
    const render = engagementTouchpoint?.items?.data?.map((row) => (
      <>
        <TableCell
          colSpan={1}
          align='center'
          sx={{ backgroundColor: '#6b8d3e', fontWeight: 'bold' }}
        >
          {row.month}
        </TableCell>
      </>
    ));

    return render;
  };
  const renderChildCell = () => {
    const render = engagementTouchpoint?.items?.data?.map((row) => (
      <>
        <TableCell align='center'>{row.data}</TableCell>
      </>
    ));
    return render;
  };
  return (
    <>
      {engagementTouchpoint?.loading ? (
        <LinearProgress />
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label='grouped table'>
            <TableHead>
              {/* First level of headers (grouped) */}
              <TableRow>
                <TableCell
                  rowSpan={2}
                  align='center'
                  sx={{ backgroundColor: '#88a364', fontWeight: 'bold', width: '300px' }}
                >
                  Total Engagement/Touchpoint
                </TableCell>
                {renderParentCell()}
              </TableRow>
              {/* Second level of headers (individual columns) */}
              <TableRow>{renderChildCell()}</TableRow>
            </TableHead>
            <TableBody>{/* ... table body rows ... */}</TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
